import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class QuickflowsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getSingleSecurityQuickflowsCollection(securityId) {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.SINGLE_SECURITY.QUICKFLOWS_COLLECTION);
        const getParams = { securityId };
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getSingleSecurityQuickflowsRedirect(quickflowId, securityId) {
        const urlParams = { quickflowId };
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.SINGLE_SECURITY.QUICKFLOWS_REDIRECT, urlParams);
        const getParams = { securityId };
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getMultiSecurityQuickflowsCollection(securityIds) {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_COLLECTION);
        const getParams = { securityIds };
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getMultiSecurityQuickflowsList() {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_LIST);
        return this.ajaxService.getDataObserveBody(url);
    }
    putMultiSecurityQuickflowsList(securityIds) {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_LIST);
        const putParams = { securityIds };
        return this.ajaxService.putDataObserveBody(url, putParams);
    }
    getMultiSecurityQuickflowsRedirect(quickflowId, securityIds) {
        const urlParams = { quickflowId };
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_REDIRECT, urlParams);
        const getParams = { securityIds };
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
}
QuickflowsService.ɵfac = function QuickflowsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuickflowsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
QuickflowsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuickflowsService, factory: QuickflowsService.ɵfac, providedIn: 'root' });
